<template>
  <div>
    <div class="upload_file_container">
      <div class="upload_file_label">
        {{ '导入文件名称' }}
      </div>
      <div>
        <el-input
          v-model="formData.fileName"
          readonly
          size="small"
          style="width: 530px"
          :placeholder="'请选择文件'"
        >
          <template #append>
            <el-upload
              class="top-upload"
              ref="topUpload"
              v-bind="uploadOpts"
              :drag="false"
              :on-change="uploadChange"
            >
              <el-button size="small">
                <span>{{ '选择文件' }}</span>
              </el-button>
            </el-upload>
          </template>
        </el-input>
        <el-button
          class="ml-2"
          size="small"
          type="primary"
          @click="downloadImportFile"
        >
          {{ '下载导入模版' }}
        </el-button>
      </div>
    </div>
    <div class="m-4">
      <div class="side-head">
        <div class="side-frame"></div>
        <div>
          {{ '导入明细' }}
        </div>
      </div>
      <DetailTable
        ref="detailTableRef"
        :items="tableData"
        :isError="isError"
        @confirm="confirm"
      ></DetailTable>
      <div class="mt-4" style="display: flex;justify-content: flex-end; ">
        <el-button @click="cancel()" size="small">
          {{ '取消' }}
        </el-button>
        <el-button type="primary" @click="save()" size="small">
          {{ '确认导入' }}
        </el-button>
      </div>
    </div>
    <el-dialog
      v-model="backDialogVisible"
      :title="'提示信息'"
      width="30%"
      append-to-body
      draggable
    >
      <span>{{ '是否要保存更改？' }}</span>
      <template #footer>
        <el-button @click="backDialogVisible = false">
          {{ '取消' }}
        </el-button>
        <el-button @click="close()">
          {{ '不保存' }}
        </el-button>
        <el-button type="primary" @click="save()">
          {{ '保存' }}
        </el-button>
      </template>
    </el-dialog>
    <ChooseImportTemplate
      :visible.sync="chooseTemplateVisible"
      :templateQueryParams="{ templateGroup: 'factory-maintenance' }"
    />
  </div>
</template>
<script>
import DetailTable from '../info-table/index.vue'
import ChooseImportTemplate from '@/views/factory/components/choose-import-template'
import EditLoading from '@/mixins/edit-loading'
import * as XLSX from 'xlsx'

export default {
  components: {
    DetailTable,
    ChooseImportTemplate,
  },
  mixins: [EditLoading],
  props: {
    visible: { default: false },
  },

  data() {
    return {
      backDialogVisible: false,
      chooseTemplateVisible: false,
      isError: false,
      formData: {
        receiveList: [],
        copyToList: [],
        fileName: '',
      },
      tableData: [],
      titleMap: {},
      uploadOpts: {
        drag: true,
        action: '#',
        accept: '.xlsx,.xls,.csv',
        'auto-upload': false,
        'show-file-list': false,
      },
    }
  },
  methods: {
    uploadChange(file) {
      this.fileUpload(file.raw)
    },
    confirm(data) {
      this.titleMap = data
    },
    fileUpload(file) {
      if (!file) return
      const fileName = file.name

      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      const { accept } = this.uploadOpts
      if (accept) {
        const types = accept.split(',')
        if (!types.includes(fileType)) {
          this.$message({
            showClose: true,
            message: '该类型的文件不支持解析',
            type: 'warning',
          })
          return
        }
      }
      this.formData.fileName = fileName
      this.parsingFiles(file)
    },

    async parsingFiles(file) {
      if (!file) return
      this.loadingOpen()
      const { json } = await this.readFile(file).catch(() => {
        this.loadingClose()
        return { json: null }
      })
      if (!json) return this.loadingClose()
      this.tableData = json.map((j) => {
        const newData = {}
        Object.keys(j).forEach((k) => {
          newData[this.titleMap[k]] =
            typeof j[k] === 'string' ? j[k].trim() : j[k]
        })
        return newData
      })
      this.isError = false
      this.loadingClose()
    },

    async readFile(file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = (ev) => {
          const binary = ev.target.result
          if (!binary) return
          const workbook = XLSX.read(binary, {
            type: 'binary',
            sheets: 0,
            cellStyles: true,
          })
          const jsonOpts = {
            defval: '',
            skipHidden: false,
            raw: false,
            range: 1,
            rawNumbers: false,
          }
          const { SheetNames, Sheets } = workbook
          const json = XLSX.utils.sheet_to_json(Sheets[SheetNames[0]], jsonOpts)
          const csvOpts = {
            FS: '<--FS-->',
            RS: '<--RS-->',
            skipHidden: false,
            rawNumbers: false,
          }
          const csv = XLSX.utils.sheet_to_csv(Sheets[SheetNames[0]], csvOpts)
          resolve({ json, csv })
        }
        reader.readAsBinaryString(file)
      })
    },

    async save() {
      const importList = this.$refs.detailTableRef.getData()
      if (!importList || importList.length == 0) {
        this.$message({
          showClose: true,
          message: '请导入数据',
          type: 'warning',
        })
        return
      }
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const res = await this.$api
        .mrpPlDeviceImportApi({ importList })
        .catch(() => null)
      loadingInstance.close()
      if (!res) return

      const { status, msg, body } = res
      const isWarning = status !== 200
      if (isWarning) {
        this.$message({
          showClose: true,
          message: msg,
          type: isWarning ? 'warning' : 'success',
        })
        return
      }
      const data = body.data
      if (!data || data.length == 0) {
        this.cancel()
        this.$emit('reload')
      } else {
        this.tableData = body.data || []
        this.isError = true
      }
    },

    cancel() {
      this.backDialogVisible = false
      this.$emit('close')
    },

    close() {
      this.backDialogVisible = true
    },

    downloadImportFile() {
      this.chooseTemplateVisible = true
    },
  },
}
</script>
<style lang="scss" scoped>
.upload_file_container {
  display: flex;
  align-items: center;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #f1f1f4;
  .upload_file_label {
    margin-right: 10px;
    color: #071437;
    font-size: 14px;
  }
}
.side-head {
  margin-top: 20px;
  display: flex;
  align-items: center;
  height: 20px;
  margin-bottom: 15px;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 15px;
}
:deep(.vxe-table) {
  border-top: none !important;
}
</style>
